export default {
  current: 1,
  pageSize: process.env.REACT_APP_PAGINATION_PAGE_SIZE || 10,
  total: 0,
  showSizeChanger: false,
  passwordHistoriesSize: 3,
  responsive: true,
  offsetNumber: 0,
};
